import { useEffect, useState, useCallback } from "react";
import api from "../api";
import DateIT from "./DateIT";
import { TaskMoveButton } from "./TaskMove";

// Incarichi collegati a una persona/contatto (scheda persona).
export default function PersonTasks({ personId }) {
  const [tasks, setTasks] = useState([]);
  const [form, setForm] = useState(null); // {title, due}

  const load = useCallback(() => {
    api.get(`/tasks?person_id=${personId}`).then((r) => setTasks(r.data)).catch(() => {});
  }, [personId]);
  useEffect(() => { load(); }, [load]);

  const toggle = async (t) => { await api.put(`/tasks/${t.id}`, { status: t.status === "fatto" ? "da_fare" : "fatto" }); load(); };
  const del = async (t) => { if (window.confirm("Eliminare l'incarico?")) { await api.delete(`/tasks/${t.id}`); load(); } };
  const save = async () => {
    if (!form.title.trim()) return;
    await api.post("/tasks", { title: form.title.trim(), due_date: form.due || null, person_id: personId });
    setForm(null); load();
  };

  return (
    <div className="panel" data-testid="person-tasks-panel">
      <div className="toolbar"><h3 style={{ margin: 0 }}>✅ Incarichi</h3><div className="spacer" />
        <button className="btn sm primary" onClick={() => setForm({ title: "", due: "" })} data-testid="person-task-new">+ Nuovo incarico</button>
      </div>
      <table>
        <thead><tr><th></th><th>Incarico</th><th>Scadenza</th><th></th></tr></thead>
        <tbody>
          {tasks.map((t) => (
            <tr key={t.id} data-testid={`person-task-${t.id}`} style={{ opacity: t.status === "fatto" ? 0.5 : 1 }}>
              <td><input type="checkbox" checked={t.status === "fatto"} onChange={() => toggle(t)} data-testid={`person-task-done-${t.id}`} /></td>
              <td><span style={{ textDecoration: t.status === "fatto" ? "line-through" : "none" }}>{t.title}</span>{t.description && <div className="muted" style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>{t.description}</div>}</td>
              <td className="muted">{t.due_date ? new Date(t.due_date).toLocaleDateString("it-IT") : "—"}</td>
              <td style={{ whiteSpace: "nowrap" }}>
                <TaskMoveButton task={t} onMoved={load} />{" "}
                <button className="btn sm danger" onClick={() => del(t)}>Elimina</button>
              </td>
            </tr>
          ))}
          {tasks.length === 0 && <tr><td colSpan={4} className="muted">Nessun incarico collegato a questa persona.</td></tr>}
        </tbody>
      </table>
      {form && (
        <div className="panel" style={{ marginTop: 10, background: "rgba(59,130,246,.08)" }}>
          <div className="field"><label>Descrizione incarico *</label><input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="person-task-title" /></div>
          <div className="field"><label>Scadenza</label><DateIT value={form.due} onChange={(v) => setForm({ ...form, due: v })} /></div>
          <div className="modal-actions">
            <button className="btn" onClick={() => setForm(null)}>Annulla</button>
            <button className="btn primary" onClick={save} data-testid="person-task-save">Crea incarico</button>
          </div>
        </div>
      )}
    </div>
  );
}
